import { useState } from "react";
import { FaHeart } from "react-icons/fa";
import ProfileList from "../../../Components/ProfileList/ProfileList";
import Pagination from "../../../Components/Pagination/Pagination";
import Spinner from "../../../Components/Spinner/Spinner";
import { ItemsPerPages } from "../../../utils/data";
import { getValueFromLocalStorage, localStorageKey } from "../../../utils/helper";
import { useFavourites, getProfileId } from "./useFavourites";
import { useMatrimonyUsers } from "../Matrimony/useMatrimonyUsers";

const Favourites = () => {
  const adminId = getValueFromLocalStorage(localStorageKey.USERDATA, "adminId");
  const role = getValueFromLocalStorage(localStorageKey.USERDATA, "role");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = ItemsPerPages;

  const {
    data: favourites = [],
    isLoading: favouritesLoading,
    isFetching: favouritesFetching,
  } = useFavourites(adminId);
  const {
    data: allUsers = [],
    isLoading: usersLoading,
    isFetching: usersFetching,
  } = useMatrimonyUsers();

  const favouriteIds = new Set(favourites.map((item) => getProfileId(item)));
  const favouriteProfiles = allUsers.filter((user) => favouriteIds.has(getProfileId(user)));

  const isLoading = favouritesLoading || usersLoading;
  const isFetching = favouritesFetching || usersFetching;

  const totalPages = Math.ceil(favouriteProfiles.length / itemsPerPage);
  const currentFavourites = favouriteProfiles.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  return (
    <div className="mt-7 flex w-full flex-col px-4 md:mt-0">
      <div className="mb-3 h-auto w-full rounded-lg bg-bgWhite p-2 shadow-md">
        <div className="flex items-center gap-2 border-b border-gray-300 px-2 py-3">
          <FaHeart className="text-red-500" />
          <h2 className="font-jost text-lg font-semibold text-textGreen">
            My Favourite Profiles ({favouriteProfiles.length})
          </h2>
        </div>

        {isLoading || isFetching ? (
          <div className="flex h-screen items-center justify-center">
            <Spinner />
          </div>
        ) : favouriteProfiles.length > 0 ? (
          <div className="mt-4">
            {currentFavourites.map((item, index) => (
              <ProfileList
                key={getProfileId(item) || index}
                role={role}
                userData={item}
              />
            ))}
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              handlePageChange={setCurrentPage}
            />
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-16 text-gray-500">
            <FaHeart className="mb-3 text-4xl text-gray-300" />
            <p>You haven&apos;t marked any profiles as favourite yet.</p>
            <p className="text-sm">
              Click the heart icon on any profile to add it here.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Favourites;
